var map = {
	"./de.json": [
		3330,
		330
	],
	"./en.json": [
		4798,
		798
	],
	"./php_de.json": [
		9744,
		744
	],
	"./php_en.json": [
		6501,
		501
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1390;
module.exports = webpackAsyncContext;